import React, { useState } from "react";
import { Breadcrumb, Button, Col } from "react-bootstrap";
import { FiHome, FiPlus, FiChevronUp } from "react-icons/fi";
import AddBudgetModal from "../../components/modals/financial-dashboard/AddBudgetModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import BudgetList from "../../components/Dashboard/finance-dashboard/BudgetList";




const BudgetsPage = () => {
  const [show, setShow] = useState(false);

  return (
    <div   style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }} className="container-fluid  p-3">

      {/* HEADER */}
      <div className="header">

     <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Budgets</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                      
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        />
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Accounting
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Budgets</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        <div className="actions">
          <Button className="add-btn" onClick={() => setShow(true)}>
            <FiPlus /> Add Budget
          </Button>

     
        </div>

      </div>
          

          
      {/* MODAL */}
      <AddBudgetModal
        show={show}
        handleClose={() => setShow(false)}
      />

      {/* CSS */}
      <style>{`
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }

        h2 {
          font-weight: 700;
        }

        .breadcrumb {
          display: flex;
        
          font-size: 14px;
          color: #6b7280;
          align-items: center;
        }

        .breadcrumb .active {
          color: #111;
          font-weight: 500;
        }

        .actions {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .add-btn{
          background: #ff7a2f;
          border: none;
          color: #fff;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        
        .add-btn:hover {
          background: #ff7a2f;
       
        }

        .collapse-btn {
          border: 1px solid #e5e7eb;
          background: #fff;
          border-radius: 6px;
          padding: 6px 10px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .actions {
            width: 100%;
            justify-content: space-between;
          }

          .add-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
       <BudgetList/>
    </div>
  );
};

export default BudgetsPage;